import { useCallback, useContext, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';
import type {
  GetClubMemberOptionsRequest,
  GetClubMemberOptionsResponse,
  HGClubMemberOptions
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

import ClubContext from '../components/Club/ClubContext/ClubContext';

const useGetClubMemberOptions = () => {
  const { setState } = useContext(ClubContext);
  const request = useRequest();
  const [loading, setLoading] = useState(false);

  const handleGetClubMemberOptions = useCallback(
    (clubId: number) => {
      setLoading(true);
      request({
        service: 'homeGames.getClubMemberOptions',
        body: { clubId } as GetClubMemberOptionsRequest
      }).subscribe({
        next: ({ body }: { body: GetClubMemberOptionsResponse }) => {
          const { error, data } = handleServerResponse<
            GetClubMemberOptionsResponse,
            HGClubMemberOptions
          >({
            response: body,
            accessor: 'memberOptions'
          });

          if (!error) {
            setState((prevState) => ({
              ...prevState,
              settings: data
            }));
          }

          setLoading(false);
        }
      });
    },
    [request, setState]
  );

  return { handleGetClubMemberOptions, loading };
};

export default useGetClubMemberOptions;
